/**
 *
 * InputValidator
 *
 */

import React from 'react';
import Wrapper from './Wrapper';

const InputValidator = ({
  hasError,
  isValid,
  offset
}) => (
  <Wrapper hasError={hasError} isValid={isValid} offset={offset}>
  </Wrapper>
);

export default InputValidator;



// WEBPACK FOOTER //
// ./src/components/InputValidator/index.js